// Lazysizes
import 'lazysizes'

// Alpine bootup

import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import mask from '@alpinejs/mask'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'

import { xAsyncForm } from './xAsyncForm'
window.xAsyncForm = xAsyncForm

import { xChoices } from './xChoices'
window.xChoices = xChoices

import Choices from 'choices.js';
window.choices = Choices

import * as Pattern from 'patternomaly'
window.pattern = Pattern

import flatpickr from "flatpickr"
import { Danish } from "flatpickr/dist/l10n/da.js"
import { Swedish } from "flatpickr/dist/l10n/sv.js"
window.flatpickrDanish = Danish
window.flatpickrSwedish = Swedish
window.flatpickr = flatpickr

import { Chart, registerables } from 'chart.js'
import zoomPlugin from 'chartjs-plugin-zoom'
Chart.defaults.borderColor = "#ffffff"
Chart.defaults.font.family = 'OrgonSlab'
Chart.defaults.color = '#142D44'
Chart.register(...registerables)
Chart.register(zoomPlugin)
window.chart = Chart

window.Alpine = Alpine
Alpine.plugin(intersect)
Alpine.plugin(mask)
Alpine.plugin(persist)
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.start()

// aspnet-client-validation bootup
import { ValidationService } from 'aspnet-client-validation'
let v = new ValidationService()
v.bootstrap()

window.v = v
